import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { DesignGallery } from "./components/DesignGallery";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { ThreeDSection } from "./components/ThreeDSection";
import { ProcessSection } from "./components/ProcessSection";
import { Testimonials } from "./components/Testimonials";
import { BlogSection } from "./components/BlogSection";
import { FAQSection } from "./components/FAQSection";
import { Footer } from "./components/Footer";
import { ContactModal } from "./components/ContactModal";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import { MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "./data/mock";

function HomePage() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="min-h-screen" data-testid="home-page">
      <Navbar onGetQuote={() => setModalOpen(true)} />
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />

      <main>
        <HeroSection onGetQuote={() => setModalOpen(true)} />
        <DesignGallery onGetQuote={() => setModalOpen(true)} />
        <WhyChooseUs onGetQuote={() => setModalOpen(true)} />
        <ThreeDSection onGetQuote={() => setModalOpen(true)} />
        <ProcessSection onGetQuote={() => setModalOpen(true)} />
        <Testimonials />
        <BlogSection />
        <FAQSection />
      </main>

      <Footer onGetQuote={() => setModalOpen(true)} />

      {/* Floating action buttons */}
      <div className="fixed bottom-6 right-4 sm:right-6 z-40 flex flex-col gap-3">
        <a
          href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(CONTACT.whatsappMsg)}`}
          target="_blank"
          rel="noreferrer"
          className="w-14 h-14 bg-[#25D366] text-white rounded-full shadow-xl flex items-center justify-center hover:scale-110 transition-transform"
          data-testid="floating-whatsapp-btn"
          title="Chat on WhatsApp"
        >
          <MessageCircle size={24} />
        </a>
        <a
          href={`tel:${CONTACT.phone}`}
          className="w-14 h-14 bg-[#C9A84C] text-white rounded-full shadow-xl flex items-center justify-center hover:scale-110 transition-transform"
          data-testid="floating-call-btn"
          title="Call Now"
        >
          <Phone size={22} />
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
